module.exports = __webpack_public_path__ + "fonts/StdKaiXHYL4EG-Md.ttf";